import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Colors card's body on the Test UI Components page: normal, muted, accent and error text on each
// background. Its look comes from the page stylesheet's cs-card-content.color-test rules.
@Component({
  selector: 'cs-test-colors-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-colors-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestColorsCardComponent {}
